import dayjs from "dayjs";
import IRestaurant from "shared/interfaces/Restaurant.interface";

import { dateIsWithinClosureDate, dateIsWithinOpeningDate } from "../date";

//If time now is during opening time periods and out of closure date
export default (restaurant: IRestaurant): boolean =>
  !dateIsWithinClosureDate(dayjs().toDate(), restaurant) &&
  dateIsWithinOpeningDate(dayjs().toDate(), restaurant);
